import { BodySmallText, H2Text } from '@prisjakt/ui/text/variants';
import { Link } from 'react-router-dom';
import { layout, media } from 'src/components/base';
import styled from 'styled-components';

export const DescriptionContainer = styled.div`
  border-top: 1px solid ${({ theme }) => theme.lines.secondary};
  margin: ${layout.measurements.spacing050};
  margin-top: ${layout.measurements.spacing150};
  margin-bottom: ${layout.measurements.spacing150};
  padding: ${layout.measurements.spacing150} 0 0 0;
  display: flex;
  ${media.smallDown`
      flex-direction: column;
    `}
`;

export const DescriptionTitle = styled(H2Text)`
  margin: 0 0 ${layout.measurements.spacing050} 0;
`;

export const DescriptionText = styled(BodySmallText)`
  display: inline-block;
  margin: 0;
  max-width: 600px;
`;

export const DescriptionBox = styled.div`
  flex-grow: 0;
`;

export const AliasLink = styled(Link)`
  color: ${p => p.theme.text.linkExternal};
  &:hover {
    color: ${p => p.theme.text.linkExternalHover};
  }
`;
